import { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface AnimatedPageProps {
  children: ReactNode;
}

function AnimatedPage({ children }: AnimatedPageProps) {
  const location = useLocation();
  const locationKey = `${location.pathname}${location.search}`;
  const [displayLocationKey, setDisplayLocationKey] = useState(locationKey);
  const [displayChildren, setDisplayChildren] = useState(children);
  const [transitionStage, setTransitionStage] = useState<'entering' | 'entered' | 'exiting'>('entered');

  useEffect(() => {
    if (locationKey !== displayLocationKey) {
      setTransitionStage('exiting');
      // Aguardar animação de saída antes de atualizar o conteúdo
      const timer = setTimeout(() => {
        setDisplayLocationKey(locationKey);
        setDisplayChildren(children);
        setTransitionStage('entering');
        // Aguardar início da animação de entrada
        const enterTimer = setTimeout(() => {
          setTransitionStage('entered');
        }, 50);
        
        return () => clearTimeout(enterTimer);
      }, 300); // Duração da animação de saída
      
      return () => clearTimeout(timer);
    } else {
      // Atualizar children sem animação se apenas props mudaram
      setDisplayChildren(children);
    }
  }, [locationKey, displayLocationKey, children]);

  return (
    <div className={`page-transition page-transition-${transitionStage}`}>
      {displayChildren}
    </div>
  );
}

export default AnimatedPage;

